module.exports = __webpack_public_path__ + "static/productpanel-5c02c1dd3eed80a7cda14bcd1e49941d.png";